module.exports = __webpack_public_path__ + "img/DE00137.10d90b88.png";